import React, { FC } from "react";
import { List, ListProps } from "@mui/material"

const ListWrapper: FC<ListProps> = ({...props}) => <List {...props}/>

export default ListWrapper;